module.exports = __webpack_public_path__ + "img/dfa2e57.svg";